/*
 * � 2020 Microsoft. All rights reserved.
 */

define('Solitaire/GameModes/GameModeFactory',[
        'Solitaire/SolitaireGameMode',
        'Solitaire/GameModes/KlondikeGameMode',
        'Solitaire/GameModes/SpiderGameMode',
        'Solitaire/GameModes/FreeCellGameMode',
        'Solitaire/GameModes/TriPeaksGameMode',
        'Solitaire/GameModes/PyramidGameMode',
        'Solitaire/GameModes/UnknownGameMode'],
    function (SolitaireGameMode, KlondikeGameMode, SpiderGameMode, FreeCellGameMode, TriPeaksGameMode, PyramidGameMode, UnknownGameMode) {
    "use strict";

        var GameModeFactory = {
            InitGameMode: function (mode) {
                var gameMode = null;

                switch (mode) {
                    case SolitaireGameMode.Klondike:
                        gameMode = new KlondikeGameMode();
                        break;

                    case SolitaireGameMode.Spider:
                        gameMode = new SpiderGameMode();
                        break;

                    case SolitaireGameMode.FreeCell:
                        gameMode = new FreeCellGameMode();
                        break;

                    case SolitaireGameMode.TriPeaks:
                        gameMode = new TriPeaksGameMode();
                        break;

                    case SolitaireGameMode.Pyramid:
                        gameMode = new PyramidGameMode();
                        break;

                    default:
                        gameMode = new UnknownGameMode();
                }

                return gameMode;
            }
        };

        return GameModeFactory;
});
